export const POLLING_CANCEL_MESSAGE = 'POLLING_CANCEL_MESSAGE';
